import InfoCardShimmer from "./InfoCardShimmer";
export default InfoCardShimmer;
